export enum FREQUENCY_MODE {
  NONE = 'none',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  CUSTOM = 'custom',
}

export type FrequencyMode =
  (typeof FREQUENCY_MODE)[keyof typeof FREQUENCY_MODE];
